export const maskPhoneNumber = (phone?: string) => {
  if (!phone) {
    return phone
  }
  const prefix = phone.slice(0, 2)
  const suffix = phone.slice(-4)
  return `${prefix} *** *** ${suffix}`
}
